
const toolbar = [
  'Upload searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent blockquote undo redo removeformat subscript superscript code  codesample fontsizeselect  fontselect hr bullist numlist link charmap preview anchor pagebreak insertdatetime media table emoticons forecolor backcolor fullscreen',
];

export default toolbar;



// WEBPACK FOOTER //
// ./src/components/Tinymce/toolbar.js